import React from "react";
import { useNavigate } from "react-router-dom";
import { SearchBarWr} from "../../../_uiComponents/common/form/UiInputComponents";
import RolesTableFilterForm from "./forms/RolesTableFilterForm";
import { MainLeftTitle, CreateButton } from '../../../_uiComponents/WrapperComponents'
import Roles from "./Roles";
import { UiAccordian } from "../../../_uiComponents/common/form/UiToggleArea";

export const RolesWrapper = () => {
    const navigate = useNavigate();
    const handleData = () => {
        let path = `/ui/create-role-table`;
        navigate(path);
    }
    return (
        <>       
            <div className='sbt-data-grid__wr'>
                <MainLeftTitle title="Role Managment">
                    <CreateButton name="Create role" onClick={handleData} />
                </MainLeftTitle>
                <UiAccordian>
                    <SearchBarWr>
                        <RolesTableFilterForm />
                    </SearchBarWr>
                </UiAccordian>

                <Roles />
            </div>
        </>
    )
}